export const ADD_GLOBAL_MESSAGE = "ADD_GLOBAL_MESSAGE"
export const REMOVE_GLOBAL_MESSAGE = "REMOVE_GLOBAL_MESSAGE"